<script>
  import {getContext, onMount, tick} from 'svelte';
  import {stores} from '@sapper/app';
  import {PATHS} from '@/const';
  import {langUtil} from '@/helper/lang';
  import {env} from '@/helper/env';
  import {getLocationSeachParam} from '@/helper/url';
  import {headerTop$} from '@/store/config';
  import {openDepositDrawer} from '@/modules/components/deposit/utils';
  import {importantAnnouncementHeight$} from './stream';
  import {showHeaderList} from './const';
  import LeftHeader from './components/LeftHeader.svelte';
  import RightHeader from './components/RightHeader.svelte';
  import JpHeaderContent from './components/JpHeaderContent.svelte';
  import MobileNavigation from './components/MobileNavigation.svelte';
  import ImportantAnnouncement from './popups/notice/ImportantAnnouncement.svelte';

  export let isLogin = false;
  export let type;

  export let showTop = false;
  export let modalUI = false;
  export let newLayout = false;
  export let isHome = false;
  export let useContractMenu = false;
  export let isDarkBg = false;

  const showTopList = [PATHS.LAUNCHPOOL.pathname, PATHS.PHEMEXIA.pathname];
  const LG = getContext('LG');
  const {page} = stores();

  let scrollTop = 0;
  let showH5Download = false;
  let innerWidth = 0;
  let headerHeight = 0;
  let isTop = true;
  let isShowHeader = true;
  let headerDom = null;

  $: updateIsHome($page, showTop);
  $: updateIsTop(isShowHeader, scrollTop, headerHeight);
  $: updateShowH5Download($page);

  onMount(() => headerTop$.set(headerDom && headerDom.clientHeight));
  onMount(() => {
    const callChainDeposit = getLocationSeachParam('callChainDeposit');
    if (callChainDeposit !== null && !sessionStorage.getItem('phemex_redirect_target')) {
      tick().then(() => {
        const passParams = getAllChainDepositParams();
        openDepositDrawer({LG, ...passParams});
      });
    }
  });

  function updateShowH5Download(page) {
    const name = langUtil.parsePathname(page.path).pathname;
    const isMarkets = name === PATHS.MARKETS.pathname;
    showH5Download = isHome || isMarkets;
  }

  function getAllChainDepositParams() {
    try {
      const search = decodeURIComponent(window.location.search);
      const searchParams = new URLSearchParams(search);
      return Object.fromEntries(searchParams) || {};
    } catch (error) {
      return {};
    }
  }

  function updateIsHome(page, showTop) {
    const name = langUtil.parsePathname(page.path).pathname;
    const isLegendTrading = name === PATHS.OTC_LEGEND_TRADING.pathname;
    const isEarnHome = name === PATHS.EARN_HOME.pathname;
    isShowHeader = !(isLegendTrading && env.isMobile) && !(isEarnHome && env.isMobile) && showHeaderList.indexOf(name) >= 0;
    if (showTop) {
      isShowHeader = !(isLegendTrading && env.isMobile) && showTopList.indexOf(name) >= 0;
    }
  }

  function updateIsTop(isShowHeader, scrollTop, headerHeight) {
    importantAnnouncementHeight$.next(headerHeight);
    isTop = isShowHeader && scrollTop <= headerHeight;
  }
</script>

<style>
  .header {
    font-weight: var(--fw2);
    color: var(--TW);
  }
  .left-content {
    /*max-width: calc(max(100vw, 1280px) - 530px);*/
    padding-right: 12px;
    /*flex: 1;*/
  }
  @media screen and (min-width: 640px) {
    .wrap {
      justify-content: space-between;
      padding: 0 20px;
      gap: 30px;
    }
    .header {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 999;
      box-sizing: border-box;
      border-bottom: 1px solid transparent;
      border-bottom: none;
      width: 100%;
      min-width: 1200px;
      height: 56px;
      background: #090a0a;
    }
    .header.bg-dark {
      border-bottom: 0;
      background: #000;
    }
    .header.log {
      border-bottom: 1px solid #1f242e;
      background: #010612;
    }
    .mwrap {
      display: none;
    }
  }
  @media screen and (max-width: 640px) {
    .wrap {
      display: none;
    }
    .mwrap {
      display: block;
    }
    .header.new-layout {
      position: sticky;
      top: -1px;
      z-index: 1999;
    }
    .header.new-layout :global(.header.fixed) {
      position: unset !important;
      height: unset;
    }
  }
</style>

<svelte:window bind:scrollY={scrollTop} bind:innerWidth />
<div style="z-index: 999;" bind:offsetHeight={headerHeight}>
  <ImportantAnnouncement />
</div>

<header class="header" class:new-layout={newLayout} class:top={(isTop && isShowHeader) || isDarkBg} class:bg-dark={isDarkBg} bind:this={headerDom} class:log={!env.isJapanSite && isLogin}>
  {#if !env.isJapanSite}
    <div class="wrap wsn df jcsb">
      <nav class="df left-content">
        <LeftHeader isTop={(isTop && isShowHeader) || isLogin || isDarkBg} />
      </nav>
      <div>
        {#if type !== 'web3'}
          <slot>
            <RightHeader isTop={(isTop && isShowHeader) || isLogin || isDarkBg} {modalUI} />
          </slot>
        {:else}
          <slot name="web3Right" isTop={(isTop && isShowHeader) || isLogin} isOpacityHeader={isShowHeader} />
        {/if}
      </div>
    </div>
  {:else}
    <JpHeaderContent>
      <RightHeader />
    </JpHeaderContent>
  {/if}
  <div class="mwrap wsn">
    <MobileNavigation isTop={!env.isJapanSite && isTop && isShowHeader} {isLogin} {modalUI} showDownload={showH5Download} />
  </div>
</header>
